import jump from 'jump.js';

export default {
  init() {
    // grab an element
    var btn = $('.back-to-top');

    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show').removeClass('unshow');
      } else {
        btn.removeClass('show').addClass('unshow');
      }
    });

    btn.on('click', () => {
      jump('body', {
        duration: 500,
      });
    });

  },
}



// WEBPACK FOOTER //
// ./scripts/modules/back-to-top.js